const roles = {
    admin : 'ROLE_ADMIN',
    finance : 'ROLE_FINANCE',
    user : 'ROLE_USER',
    customer : 'ROLE_CUSTOMER'
};

export default {
    roles: roles,
    authenSuccesUrlRedirect : function(hasAuthor) {
        // if(hasAuthor(roles.admin)) {
        //     return '/user-management/managed-users';
        // } else if(hasAuthor(roles.user) || hasAuthor(roles.customer)) {
        //     return '/user-management/managed-users';
        // } else return '/user-management/my-profile';
        return '/user-management/my-profile';
    },

    authorizationMapper : [
        {
            regex: /^\/system-management\/.*/,
            isAuthorized : function(hasAuthor) {
                return hasAuthor(roles.admin);
            }
        },
        {
            regex: /^\/statistics-management\/.*/,
            isAuthorized : function(hasAuthor) {
                return hasAuthor(roles.admin);
            }
        },
        {
            regex: /^\/user-management\/managed-users/,
            isAuthorized : function(hasAuthor) {
                return hasAuthor(roles.admin);
            }
        }
    ]
}
